import { Link } from 'react-router-dom';
import { forexBasicsHero } from '@/mocks/forexBasics';
import RateReferenceCard from '@/pages/forex-basics/components/RateReferenceCard';

export default function BasicsHero() {
  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0 grid-lines opacity-50" />
      <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 left-1/4 h-64 w-64 rounded-full bg-accent-100/50 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:px-10 lg:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-primary-700">
              <span className="h-px w-5 bg-accent-500" />
              {forexBasicsHero.eyebrow}
            </span>

            <h1 className="mt-5 text-balance font-heading text-3xl font-semibold leading-tight text-foreground-950 md:text-5xl">
              {forexBasicsHero.title}
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              {forexBasicsHero.description}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href={forexBasicsHero.primaryTarget}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                {forexBasicsHero.primaryCta}
                <i className="ri-arrow-down-line text-base" />
              </a>
              <Link
                to={forexBasicsHero.secondaryTarget}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {forexBasicsHero.secondaryCta}
                <i className="ri-arrow-right-line text-base" />
              </Link>
            </div>

            <dl className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-background-200 pt-6">
              {forexBasicsHero.highlights.map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div>
                    <dt className="font-num text-sm font-semibold text-foreground-950">{item.value}</dt>
                    <dd className="text-xs text-foreground-500">{item.label}</dd>
                  </div>
                </div>
              ))}
            </dl>
          </div>

          <RateReferenceCard />
        </div>
      </div>
    </section>
  );
}